import React, { useMemo, useState, useEffect } from 'react';
import { Spin, Tooltip, Button } from 'antd';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { debounce, ceil, trim } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import Modal from '../../../components/uiComponent/modal/index'

import Search from '../../../components/uiComponent/inputs/searchinput';
import Badge from '../../../components/uiComponent/bages';
import AgGrid from '../../../components/ag-grid-table/index';
import Pagination from '../../../components/pagination';
import Select from '../../../components/uiComponent/select/index';
import CustomTabs from '../../../components/uiComponent/customTabs';
import { PoWarehouseWrapper, ModalWrapper} from './style';
import { getPoUsers, getWarehousePos, UpdatePo } from '../../../slices/po';
import { PO_STATUSES } from '../../../constants/warehousePo';
import { STORAGE_ICON_URL } from '../../../constants/storage'
const SideDrawerIcon = `${STORAGE_ICON_URL}/side-bar-icon.svg`;
const WarningIcon = `${STORAGE_ICON_URL}/warning-modal-icon.svg`;
const MarkAsResolved = `${STORAGE_ICON_URL}/mark-as-resolved-icon.svg`;

const defaultColDef = {
  resizable: true,
  sortable: false,
  suppressMenu: true,
  suppressMovable: true,
  suppressSorting: true,
};

let gridColumnApi

const PoWarehouse = () => {
  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '', user_id: '',status:'' });
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [activeStatus, setActiveStatus] = useState(null); 
  const [id, setId] = useState(null)
  const {
    warehousePos,
    totalWarehousePosCount,
    fetchingWarehousePos,
    poUsers,
    fetchingPoUsers,
    updatePoLoading,
    warehousePoAllStatusCount
  } = useSelector((state) => state.pos || {});
  console.log(fetchingWarehousePos,"Check loading")

  useEffect(() => {
    dispatch(getWarehousePos({ page, filters, sortBy }));
    dispatch(getPoUsers());
  }, []);

  const handleClose = ()=>{
    setIsModalOpen(false)
  }
  
  const handlePoUpdate = ()=>{
    dispatch(UpdatePo({ poId:String(id), status:"Arrived" })).then(()=>{
    refreshGridClick()
    })
    setIsModalOpen(false);
 }
  const statuses = [
    {
      id: 'Confirmed',
      label: 'Confirmed',
      count: warehousePoAllStatusCount['Confirmed'] || 0,
      activeBg: '#1565D8',
      inactiveBg: '#1565D833',
      activeText: '#fff',
      inactiveText: '#1565D8',
      activeCountBg: '#fff',
      inactiveCountBg: '',
      activeCountText: '#fff',
      inactiveCountText: '#1565D8',
      activeBorder: '#1565D8',
      inactiveBorder: '#1565D8',
      width: 182
    },
    {
      id: 'Arrived',
      label: 'Arrived',
      count: warehousePoAllStatusCount['Arrived'] || 0,
      activeBg: '#009C34',
      inactiveBg: '#009C3433',
      activeText: '#fff',
      inactiveText: '#009C34',
      activeCountBg: '#fff',
      inactiveCountBg: '',
      activeCountText: '#fff',
      inactiveCountText: '#009C34',
      activeBorder: '#009C34',
      inactiveBorder: '#009C34',
      width: 182
    },
    {
      id: 'Receiving',
      label: 'Receiving',
      count: warehousePoAllStatusCount['Receiving'] || 0,
      activeBg: '#47B5FF',
      inactiveBg: '#47B5FF33',
      activeText: '#fff',
      inactiveText: '#47B5FF',
      activeCountBg: '#fff',
      inactiveCountBg: '',
      activeCountText: '#fff',
      inactiveCountText: '#47B5FF',
      activeBorder: '#47B5FF',
      inactiveBorder: '#47B5FF',
      width: 182
    },
    {
      id: 'Processed',
      label: 'Processed',
      count: warehousePoAllStatusCount['Processed'] || 0,
      activeBg: '#9747FF',
      inactiveBg: '#9747FF33',
      activeText: '#fff',
      inactiveText: '#9747FF',
      activeCountBg: '#fff',
      inactiveCountBg: '',
      activeCountText: '#fff',
      inactiveCountText: '#9747FF',
      activeBorder: '#9747FF',
      inactiveBorder: '#9747FF',
      width: 182
    },
  ];
  const columnDefs = useMemo(
    () => [
      {
        headerName: 'Date',
        field: 'created_at',
        minWidth: 120,
        sortable: true,
        comparator: () => 0,
        flex: 1,
        cellRenderer: ({ value }) => {
          if (!value) return '';
          const date = new Date(value);
          return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
        },
        valueFormatter: (params) => `${params?.value || '-'}`,
      },
      {
        headerName: 'Vendor Name',
        minWidth: 130,
        flex: 1,
        field: 'vendor.name',
        valueFormatter: (params) => `${params?.value || 'N/A'}`,
      },
      {
        headerName: 'Customer Name',
        minWidth: 200,
        field: 'user.first_name',
        flex: 1,
      },
      {
        headerName: 'PO Name',
        minWidth: 200,
        field: 'file_name',
        flex: 1,
      },
      {
        headerName: 'Status',
        minWidth: 120,
        flex: 1,
        field: 'status',
        cellRenderer: ({ value }) => <Badge status={value} />,
      },
      {
        headerName: 'Ordered Quantity',
        minWidth: 130,
        flex: 1,
        field: 'ordered_quantity',
        comparator: () => 0,
        sortable: true,
        valueFormatter: (params) => `${Number(params?.value || 0)?.toLocaleString('en-US')}`,
      },
      {
        headerName: 'Invoice Quantity',
        minWidth: 120,
        field: 'invoice_quantity',
        flex: 1,
        comparator: () => 0,
        sortable: true,
        valueFormatter: (params) => `${Number(params?.value || 0)?.toLocaleString('en-US')}`,
      },
      {
        headerName: 'Received Quantity',
        minWidth: 120,
        field: 'received_quantity',
        flex: 1,
        comparator: () => 0,
        sortable: true,
        valueFormatter: (params) => `${Number(params?.value || 0)?.toLocaleString('en-US')}`,
      },
      {
        headerName: 'Missing Units',
        minWidth: 140,
        field: 'missing_units',
        sortable: true,
        flex: 1,
        comparator: () => 0,
        cellRenderer: ({ data }) => {
          const missingUnits = data?.missing_units || 0;
          return <>{missingUnits?.toLocaleString('en-US')}</>;
        }
      },
      {
        headerName: 'Action',
        field: 'action',
        minWidth: 160,
        flex: 1,
        cellRenderer: ({ data }) => (
          <>
          <Tooltip title='Details Page'>
          <img
            className='cursor-pointer'
            style={{marginRight:'30px'}}
            src={SideDrawerIcon}
            onClick={() => handleNavigatePo(data?.id)}
            alt='SideDrawerIcon'
          />
          </Tooltip>
            <Button className={ data?.status?.toLowerCase() === 'confirmed' ? "map-btn-wrapper" : 'disabled-save-button'} onClick={()=>{
              setId(data?.id)
              setIsModalOpen(true)
              }}>Mark As Arrived</Button>
          </>
        ),
      },
    ],
    []
  );

  const handleSearchPo = debounce((value) => {
    if (trim(value) || filters.search) {
      setFilters((filters) => ({ ...filters, search: trim(value) }));
      setPage(page => ({ ...page, pageNumber: 1 }));
      dispatch(
        getWarehousePos({
          page: { ...page, pageNumber: 1 },
          filters: { ...filters, search: trim(value) },
          sortBy,
        })
      );
    }
  }, 800);

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    dispatch(
      getWarehousePos({
        page: newPage,
        filters,
        sortBy,
      })
    );
  };

  const gridReady = (params) => {
    gridColumnApi = params.columnApi
  }

  const refreshGridClick = () => {
    if (gridColumnApi) {
      gridColumnApi.applyColumnState({
        defaultState: { sort: null },
        applyOrder: true,
      });
      setSortBy({ key: '', type: '' })
    }
    dispatch(
      getWarehousePos({
        page,
        filters,
      })
    );
  };

  const handleNavigatePo = (id) => {
    navigate(`/po-warehouse-details/${id}`);
  };

  const { pageNumber, pageSize } = page || {};

  const handleFilterChange = ({ key, value }) => {
    setFilters((filters) => ({ ...filters, [key]: value }));
    setPage((page) => ({ ...page, pageNumber: 1 }));
    dispatch(
      getWarehousePos({
        page: { ...page, pageNumber: 1 },
        filters: { ...filters, [key]: value },
        sortBy,
      })
    );
  };

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find((s) => s.sort != null);

    if (
      value &&
      ['ordered_quantity', 'received_quantity', 'invoice_quantity','created_at', 'missing_units'].includes(
        value?.colId
      )
    ) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      dispatch(
        getWarehousePos({
          page,
          filters,
          sortBy: { key: colId, type: sort },
        })
      );
    }
  };
  return (
    <PoWarehouseWrapper>
      <div className='bar-item'>
        <Search
          className='search'
          placeholder='Search by PO Name, UPC'
          onChange={({ target }) => handleSearchPo(target.value)}
        />
        <Select
          isClearable={true}
          placeholder='Filter By Customer'
          className='mb-0 filter'
          loading={fetchingPoUsers}
          options={poUsers}
          onChange={(e) =>
            handleFilterChange({ key: 'user_id', value: e?.value })
          }
        />
        {/* <Select
          isClearable={true}
          placeholder='Filter By Status'
          className='mb-0 select-status '
          // loading={fetchingPoUsers}
          options={PO_STATUSES}
          onChange={(e) =>
            handleFilterChange({ key: 'status', value: e?.value })
          }
        /> */}
      </div>
      <Box mb={2}>
        <CustomTabs
          tabs={[
            {
              id: null,
              label: 'All',
              content: null,
              activeBg: '#1565D8',
              inactiveBg: '#E0E7FF',
              activeText: '#ffffff',
              inactiveText: '#1D4ED8',
              activeCountBg: '#ffffff',
              inactiveCountBg: '#E0E7FF',
              activeCountText: '#1D4ED8',
              inactiveCountText: '#1D4ED8',
              activeBorder: '#ffffff',
              inactiveBorder: '#1D4ED8',
              width: 100
            },
            ...statuses.map((status) => ({
              ...status,
              content: null,
            })),
          ]}
          activeTab={activeStatus}
          onTabClick={(id) => {
            setActiveStatus(id);
            handleFilterChange({ key: 'status', value: id });
          }}
        />
      </Box>
      <Spin tip='Loading...' spinning={ fetchingWarehousePos || updatePoLoading }>
        <AgGrid
          gridReady={gridReady}
          user_referrals={warehousePos}
          defaultColDef={defaultColDef}
          columnDefinitions={columnDefs}
          rowHeight={64}
          headerHeight={36}
          height='266px'
          masterDetail={false}
          detailRowAutoHeight={false}
          onSortChange={onSortChange}
          className='sku-table'
        />
      </Spin>
      <Pagination
        total={totalWarehousePosCount}
        totalPages={ceil(totalWarehousePosCount / pageSize + 1)}
        pageNumber={pageNumber}
        pageLimit={pageSize}
        handleLimitChange={(e) => handlePagination(e, 'pageSize')}
        handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
        refreshGridClick={refreshGridClick}
      />
      <Modal
        open={isModalOpen}
        onClose={handleClose}
        onHide={handleClose}
        closeText='Cancel'
        saveText='Confirm'
        header='Arrived Confirmation'
        className='delete-confirmation-modal'
        closeButton={true}
        onSave={handlePoUpdate}
      >
        <ModalWrapper>
          <div className='delete-modal-wrapper'>
            <img src={MarkAsResolved} alt='WarningIcon' title='WarningIcon' />
            <h3>Mark As Arrived</h3>           
              <p>Do You Mark This PO As Arrived ?</p>
          </div>
          </ModalWrapper>
      </Modal>
    </PoWarehouseWrapper>
  );
};

export default PoWarehouse;
